/**
 * Roset — sepet çekmecesi önerileri için tıklama dinleyicisi.
 * Çekmece içeriği her güncellemede yeniden çizildiğinden dinleyici belgeye bir kez bağlanır.
 */
import { rosetAddToCart } from './roset-cart.js';

if (!window.__rosetUpsellBound) {
  window.__rosetUpsellBound = true;

  document.addEventListener('click', async (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-rcu-add]') : null;
    if (!btn) return;
    event.preventDefault();

    btn.setAttribute('aria-busy', 'true');
    try {
      await rosetAddToCart(btn, [{ id: btn.getAttribute('data-rcu-add'), quantity: 1 }]);
    } catch (e) {
      console.warn('[roset-upsell]', e);
      btn.removeAttribute('aria-busy');
    }
  });
}
